import { Injectable } from '@angular/core';

import { nameValue } from '@firestitch/common';
import { IFilterConfigAutocompleteItem, ItemType } from '@firestitch/filter';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TimezoneData } from './../data/timezone.data';


interface ITimeZone {
  name: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class FilterService {

  private _timezone$ = new BehaviorSubject(undefined);

  public get timezone$(): Observable<ITimeZone> {
    return this._timezone$
      .pipe(
        filter((value) => value !== undefined),
      );
  }

  public get timezone() {
    return this._timezone$.getValue();
  }

  constructor(private _timezoneData: TimezoneData) {
    this._loadUserTimeZone();
  }

  public getTimezoneFilter(): IFilterConfigAutocompleteItem {
    return {
      name: 'timezone',
      type: ItemType.AutoComplete,
      label: 'Timezone',
      default: this.timezone,
      values: (keyword) => {
        return this._timezoneData.gets({ keyword })
          .pipe(
            map((response) => nameValue(response, 'description', 'identifier')),
          );
      },
    };
  }

  private _loadUserTimeZone(): void {
    this._timezoneData
      .gets({
        identifier: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
      .subscribe((response) => {
        if (response.length > 0) {
          this._timezone$.next({
            name: response[0].description,
            value: response[0].identifier,
          });
        } else {
          this._timezone$.next(null);
        }
      });
  }

}
